import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/logo.png';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="container-fluid">
    <div className="row">
       <div className='col-12 col-md-3'>
          <Sidebar />
        </div>
         
        <div className='col-12 col-md-8'>

          {children}
        </div>
    </div>
    </div>
  );
}
